import { render, staticRenderFns } from "./TabExtensionTemplateSelect.vue?vue&type=template&id=0f425c0a&scoped=true&"
import script from "./TabExtensionTemplateSelect.vue?vue&type=script&lang=js&"
export * from "./TabExtensionTemplateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f425c0a",
  null
  
)

export default component.exports